import { SectionDTO, SectionName } from '../../types/types'
import {
  ActionType,
  PromoPageActions,
  SAVE_SECTION,
  SET_IS_CHANGES_UPDATING_BLOCKED,
  SET_SECTION_ORDER,
  SET_SECTIONS,
} from './actions'
import { PromoPageState, SectionState } from './state'

export function promoPageStateReducer(state: PromoPageState, action: PromoPageActions): PromoPageState {
  switch (action.type) {
    case ActionType.SET_SECTION_ORDER: {
      const array = [...state.sections]

      const oldElem = array.find((el) => el.index === action.payload.oldIndex)
      const newElem = array.find((el) => el.index === action.payload.newIndex)
      oldElem!.index = action.payload.newIndex
      newElem!.index = action.payload.oldIndex

      array.sort((a, b) => a.index - b.index)

      return {
        ...state,
        sections: array,
      }
    }

    case ActionType.SAVE_SECTION: {
      const array = state.sections.map((item) => {
        if (item.type === action.payload.section.type) {
          item = action.payload.section
        }

        return item
      })

      return {
        ...state,
        sections: array,
      }
    }

    case ActionType.SET_SECTIONS: {
      const array: SectionState[] = []
      /* console.log('Секции с сервера', action.payload.sections) */
      action.payload.sections.forEach((item) => {
        const currentSection = state.sections.find((stateSection) => stateSection.type === item.type) as SectionState

        const parsedSectionFromServer = {
          type: item.type as SectionName,
          content: item.content,
          index: item.index,
        }

        /*          console.log(`Распарсеная секциия с сервера ${parsedSectionFromServer.type}`, parsedSectionFromServer) */

        array.push({
          ...currentSection,
          ...parsedSectionFromServer,
        })
      })

      array.sort((a, b) => {
        return a.index - b.index
      })

      /*  console.log('Распарсеные секции с сервера', array) */

      return {
        ...state,
        sections: array,
      }
    }

    case ActionType.SET_IS_CHANGES_UPDATING_BLOCKED: {
      return {
        ...state,
        isChangesUpdatingBlocked: true,
      }
    }

    default:
      return state
  }
}

export const setSectionOrder = (oldIndex: number, newIndex: number): SET_SECTION_ORDER => ({
  type: ActionType.SET_SECTION_ORDER,
  payload: { oldIndex: oldIndex, newIndex: newIndex },
})

export const saveSection = (section: SectionState): SAVE_SECTION => ({
  type: ActionType.SAVE_SECTION,
  payload: {
    section: section,
  },
})

export const setSections = (sections: SectionDTO[]): SET_SECTIONS => {
  return {
    type: ActionType.SET_SECTIONS,
    payload: {
      sections: sections,
    },
  }
}

export const setIsChangesUpdatingBlocked = (): SET_IS_CHANGES_UPDATING_BLOCKED => ({
  type: ActionType.SET_IS_CHANGES_UPDATING_BLOCKED,
})
